module.exports = __webpack_public_path__ + "img/darknuera.b88f6229.png";